let editModeKey = 'IS_IN_EDIT_MODE';

export const isInEditMode = () => !!window[editModeKey];
export const setEditMode = mode => (window[editModeKey] = mode);
export const setEditModeKey = key => {
  editModeKey = key;
};
export default isInEditMode;
